import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    onClick: _ctx.toggle,
    icon: _ctx.active ? 'close' : 'menu',
    size: "xl",
    "text-color": "primary",
    dense: true,
    flat: true,
    padding: "0 0.5rem"
  }, null, 8, ["onClick", "icon"]))
}